import script from "./NotificationsWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsWidget.vue?vue&type=script&setup=true&lang=js"

import "./NotificationsWidget.vue?vue&type=style&index=0&id=22a0ce30&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22a0ce30"]])

export default __exports__